import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Elavtal = lazy(() => import("@/pages/elavtal/Elavtal"));

export const Route = createFileRoute("/elavtal/")({
  head: () => seoHead("/elavtal"),
  component: () => <Elavtal />,
});
